import { type CanonicalIcd10Code, canonicalClinicalCode, isHistoryAndStatusIcd10Code } from "@smartmed/codes";

import type { OrderedIcd10Codes } from "./examinationEncounterCodes";

export const HISTORY_OR_STATUS_PRIMARY_REVIEW_FLAG_TEXT = "Z80-Z99 code in primary diagnosis position";

export const HISTORY_OR_STATUS_PRIMARY_WARNING_TEXT = "Z80-Z99 codes can't be the primary diagnosis (DCS.XXI.21)";

/** Z85.6 and Z85.7 are the history of leukaemia and of other lymphoid and haematopoietic malignancies, which DCS.XXI.21 lets lead. */
const PERMITTED_PRIMARY_CODES: ReadonlySet<string> = new Set(["Z85.6", "Z85.7"]);

export const findHistoryOrStatusPrimaryCode = (
  orderedIcd10Codes: OrderedIcd10Codes,
): CanonicalIcd10Code | undefined => {
  const primary = orderedIcd10Codes[0];
  if (primary === undefined) return undefined;

  return isHistoryAndStatusIcd10Code(primary) && !PERMITTED_PRIMARY_CODES.has(canonicalClinicalCode(primary))
    ? primary
    : undefined;
};

export const historyOrStatusPrimaryWarnings = (orderedIcd10Codes: OrderedIcd10Codes) => {
  const code = findHistoryOrStatusPrimaryCode(orderedIcd10Codes);
  return code === undefined ? [] : [{ code, index: 0, message: HISTORY_OR_STATUS_PRIMARY_WARNING_TEXT }];
};
